// src/components/PageTitle.tsx
import React from "react";
import { Typography } from "@mui/material";

export default function PageTitle({ children }: { children: React.ReactNode }) {
  return (
    <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700 }}>
      {children}
    </Typography>
  );
}
